export const UPDATE_SELECTION = 'UPDATE_SELECTION';
export const CLEAR_SELECTION = 'CLEAR_SELECTION';
export const CLEAR_MULTIPLE_SELECTIONS = 'CLEAR_MULTIPLE_SELECTIONS'; 